import { MISSING_VALUE } from '@constants/stats';
import { RowModel } from './columns';
import { ReactNode } from 'react';

type StatisticallySignificantProps = {
  row: RowModel;
  children: ReactNode;
};

export const StatisticallySignificant = (
  props: StatisticallySignificantProps
) => {
  if (!props.row.statisticallySignificant) return MISSING_VALUE;

  return props.children;
};
